@if (isLoading || isEmpty) {
  <div
    class="outer"
    [ngClass]="{ light: theme === 'light', dark: theme === 'dark' }"
  >
    @if (isLoading) {
      <div class="loading-box" [style.min-height.px]="containerHeight">
        <div class="spinner">
          <div class="spinner-container">
            <div
              class="spinner"
              [style.height.px]="diameter"
              [style.width.px]="diameter"
            >
              @if (spinner) {
                <mat-progress-spinner
                  [strokeWidth]="stroke"
                  [diameter]="diameter"
                  [color]="'primary'"
                  [mode]="'indeterminate'"
                >
                </mat-progress-spinner>
              }
              @if (animation) {
                <lottie-player
                  slot="end"
                  autoplay
                  loop
                  src="../../../../assets/logo-anim.json"
                >
                </lottie-player>
              }
            </div>
          </div>
          @if (!no_message) {
            <div>
              <div class="message">{{ message ? message : "LOADING" }}</div>
            </div>
          }
        </div>
      </div>
    }
    @if (!isLoading && isEmpty) {
      <div class="empty-box appear_1">
        @if (!noImage) {
          <img
            [src]="
              image ? '/assets/' + image : '/assets/empty' + random + '.svg'
            "
          />
        }
        <div class="celo-text-18 celo-bold title_text">{{ title }}</div>
        <div class="celo-text-14 celo-grey text">{{ message }}</div>
      </div>
    }
  </div>
}

<img src="../../assets/no-internet.png" class="hidden" />

@if (type === "no_internet") {
  <div>
    <div class="empty-box no-internet appear_1">
      <img src="../../assets/no-internet.png" />
      <div class="celo-text-18 celo-bold">{{ title }}</div>
      <div class="subtitle">{{ message }}</div>
    </div>
  </div>
}
